import {
  Laptop,
  Shirt,
  Coffee,
  ShieldCheck,
  Grid,
  ArrowUpCircle,
  SquareChevronUp,
  Tv,
  PlayCircle,
  Bell,
  Shirt as IronIcon,
  Waves,
  SprayCan,
  Mountain,
  Coffee as TeaCoffeeIcon,
  Footprints,
  Scissors,
  Tv as TvIcon,
  PlaySquare,
  Wine,
  Bath,
  Flame,
  Wind as SingleAcIcon,
  Thermometer,
  Phone,
  Droplets,
  Radio,
  Shirt as WardrobeIcon,
  ScrollText,
  Headphones,
  Satellite,
  Wind,
  Droplet,
  Lock,
  LucideIcon,
  Check,
} from "lucide-react";

interface FacilityIconMap {
  [key: string]: {
    icon: LucideIcon;
    displayName: string;
  };
}

export const facilityIconMap: FacilityIconMap = {
  "Laptop safe": { icon: Laptop, displayName: "Laptop Safe" },
  Bathrobe: { icon: Shirt, displayName: "Bathrobe" },
  "Coffee machine": { icon: Coffee, displayName: "Coffee Machine" },
  Safe: { icon: ShieldCheck, displayName: "Safe" },
  "Hardwood or parquet floors": { icon: Grid, displayName: "Hardwood Floors" },
  "Upper floors accessible by elevator": {
    icon: ArrowUpCircle,
    displayName: "Elevator Access",
  },
  "Upper floors accessible by stairs only": {
    icon: SquareChevronUp,
    displayName: "Stairs Only",
  },
  "Flat-screen TV": { icon: Tv, displayName: "Flat-screen TV" },
  "Pay-per-view channels": { icon: PlayCircle, displayName: "Pay-per-view" },
  "Wake-up service": { icon: Bell, displayName: "Wake-up Service" },
  Iron: { icon: IronIcon, displayName: "Iron" },
  Towels: { icon: Waves, displayName: "Towels" },
  "Ironing facilities": { icon: IronIcon, displayName: "Ironing Facilities" },
  "Free toiletries": { icon: SprayCan, displayName: "Free Toiletries" },
  "Inner courtyard view": { icon: Mountain, displayName: "Courtyard View" },
  "Tea/Coffee maker": { icon: TeaCoffeeIcon, displayName: "Tea/Coffee Maker" },
  Slippers: { icon: Footprints, displayName: "Slippers" },
  Hairdryer: { icon: Scissors, displayName: "Hairdryer" },
  TV: { icon: TvIcon, displayName: "TV" },
  "Streaming service": { icon: PlaySquare, displayName: "Streaming Service" },
  "Streaming service (like Netflix)": {
    icon: PlaySquare,
    displayName: "Streaming Service",
  },
  Minibar: { icon: Wine, displayName: "Minibar" },
  Toilet: { icon: Bath, displayName: "Toilet" },
  "Electric kettle": { icon: Flame, displayName: "Electric Kettle" },
  "Single-room AC": { icon: SingleAcIcon, displayName: "Single-room AC" },
  Heating: { icon: Thermometer, displayName: "Heating" },
  Telephone: { icon: Phone, displayName: "Telephone" },
  Shower: { icon: Droplets, displayName: "Shower" },
  "Cable channels": { icon: Radio, displayName: "Cable Channels" },
  "Wardrobe or closet": { icon: WardrobeIcon, displayName: "Wardrobe" },
  "Toilet paper": { icon: ScrollText, displayName: "Toilet Paper" },
  Soundproof: { icon: Headphones, displayName: "Soundproof" },
  "Satellite channels": { icon: Satellite, displayName: "Satellite Channels" },
  "Air conditioning": { icon: Wind, displayName: "Air Conditioning" },
  "Hand sanitizer": { icon: Droplet, displayName: "Hand Sanitizer" },
  "Private bathroom": { icon: Lock, displayName: "Private Bathroom" },
};

export const getFacilityIcon = (facilityName: string) => {
  const normalizedName = facilityName.toLowerCase().trim();
  const match = Object.entries(facilityIconMap).find(
    ([key]) => key.toLowerCase() === normalizedName
  );
  const defaultIcon = { icon: Check, displayName: facilityName };

  return match ? match[1] : defaultIcon;
};
